import { render } from "./CellTable_220125.vue?vue&type=template&id=620e964d&scoped=true"
import script from "./CellTable_220125.vue?vue&type=script&lang=js"
export * from "./CellTable_220125.vue?vue&type=script&lang=js"

import "./CellTable_220125.vue?vue&type=style&index=0&id=620e964d&scoped=true&lang=css"

import exportComponent from "C:\\Apps\\AppBase\\app-base-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-620e964d"]])

export default __exports__